import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  eventmodal: false,
};

export const brokerSlice = createSlice({
  name: "broker",
  initialState,
  reducers: {},
});

export const {} = brokerSlice.actions;

export const brokerReducer = brokerSlice.reducer;
